import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Chip, Typography } from "@mui/material";
import { Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";

import { IContractTerminationReason } from "../../../../models/contract-termination-reason";
import {
  contractTerminationService,
  buildTPath,
} from "./contract-termination-reason.utils";

const ContractTerminationReasonPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const columns: GridColDef<IContractTerminationReason>[] = [
    {
      field: "code",
      headerName: t(buildTPath("code"))!,
      renderCell: ({ value }) => (
        <Typography variant="body2">{value}</Typography>
      ),
    },
    {
      field: "name",
      headerName: t(buildTPath("name"))!,
    },
    {
      field: "enable",
      headerName: t(buildTPath("status"))!,
      renderCell: ({ value }) => (
        <Chip
          size="small"
          color={value ? "success" : "error"}
          label={value ? t(buildTPath("active")) : t(buildTPath("inactive"))}
        />
      ),
    },
  ];

  const handleRowClick = ({
    id,
  }: GridRowParams<IContractTerminationReason>) => {
    navigate(`${id.toString()}/edit`);
  };

  const handleAdd = () => {
    navigate("new");
  };

  return (
    <Table<IContractTerminationReason>
      showDefaultMacroFilters={false}
      service={contractTerminationService}
      columns={columns}
      title={t(buildTPath("title"))}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={t(buildTPath("search"))}
      addButtonLabel={t(buildTPath("add"))!}
      confirmOptions={{
        title: t(buildTPath("confirm.title")),
        description: t(buildTPath("confirm.description")),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default ContractTerminationReasonPage;
